import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Mappers } from '@grandvisionhq/carts-v2';
import { PaymentMethod } from '@grandvisionhq/payments';
import { useTealiumEventProperties, useDispatchTrackPageView } from '@grandvisionhq/svc-tealium/events';
import { getOrderPriceInfo, orderToTealiumOrderDiscountInfo, getOrderSubscriptionFrequency } from '../../tealium-mapper.js';

const useOrderConfirmTealiumEvent = ()=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const dispatchPageView = useDispatchTrackPageView();
    const getPaymentType = (order)=>{
        var ref;
        const paymentMethod = order.paymentMethod.value === PaymentMethod.CREDITCARD || order.paymentMethod.value === 'CARD' ? order === null || order === void 0 ? void 0 : (ref = order.paymentDetails) === null || ref === void 0 ? void 0 : ref.type : order.paymentMethod.value;
        switch(paymentMethod){
            case 'jcb':
                return 'JCB';
            case 'visa':
                return 'Visa';
            case 'mc':
            case 'mastercard':
                return 'MasterCard';
            case 'maestro':
                return 'Maestro';
            case 'amex':
                return 'Amex';
            case 'diners':
                return 'Diners';
            case 'bcmc':
            case 'bancontact':
                return 'Bancontact';
            case 'discover':
                return 'Discover';
            case PaymentMethod.APPLE_PAY:
                return 'ApplePay';
            case PaymentMethod.IDEAL:
                return 'Ideal';
            case PaymentMethod.BANCONTACT_CARD:
            case PaymentMethod.BANCONTACT_MOBILE:
                return 'Bancontact';
            case PaymentMethod.KLARNA:
            case PaymentMethod.KLARNA_ACCOUNT:
            case PaymentMethod.KLARNA_PAY_NOW:
                return 'Klarna';
            case PaymentMethod.PAYPAL:
                return 'PayPal';
            default:
                return order.paymentMethod.value;
        }
    };
    const handleOrderConfirmPageEventDispatch = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(order) {
            const commonUserProperties = yield getCommonUserProperties();
            if (!commonUserProperties) return;
            const priceInfo = getOrderPriceInfo(order);
            const products = Mappers.mapVisualLineItemProductToTealiumProduct(order.lineItems, true);
            const discountInfo = orderToTealiumOrderDiscountInfo(order);
            const shippingInfo = Mappers.getCartToTealiumShippingInfo(order.deliveryMethod);
            dispatchPageView(()=>{
                var ref;
                return Promise.resolve(swcHelpers.objectSpread({
                    id: 'VirtualPage-View',
                    Page_Section1: 'Checkout',
                    Page_Section2: 'Standard',
                    Page_Type: 'Thankyou',
                    Products: products,
                    Order_Id: order.orderNumber,
                    Order_PaymentType: getPaymentType(order),
                    Order_SubscriptionFrequency: getOrderSubscriptionFrequency(order),
                    Store_Search_StoreId: (order === null || order === void 0 ? void 0 : (ref = order.serviceStore) === null || ref === void 0 ? void 0 : ref.code) ? order.serviceStore.code.toString() : ''
                }, commonUserProperties, commonEventProperties, priceInfo, discountInfo, shippingInfo));
            });
        });
        return function(order) {
            return _ref.apply(this, arguments);
        };
    }(), [
        commonEventProperties,
        dispatchPageView,
        getCommonUserProperties
    ]);
    return {
        handleOrderConfirmPageEventDispatch
    };
};

export { useOrderConfirmTealiumEvent };
//# sourceMappingURL=use-order-confirm-tealium-event.js.map
